import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useEffect, useState } from 'react';
import { Debug } from '../debug/Debug.js';
import { PubSub } from '../debug/PubSub.js';
var getInitialState = function getInitialState(key, initialState) {
    var debugState = Debug.getState(key);
    return debugState && Object.keys(debugState).length !== 0 ? debugState : initialState;
};
export var useDebugState = function useDebugState(key, initialState) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        withOverload: true
    };
    var _useState = _sliced_to_array(useState(getInitialState(key, initialState)), 2), state = _useState[0], setState = _useState[1];
    var addState = function addState(attribute, value) {
        setState(function(prev) {
            var newState = _object_spread_props(_object_spread({}, prev), _define_property({}, attribute, value));
            Debug.setState(key, function() {
                return newState;
            }, options.withOverload);
            return newState;
        });
    };
    var replaceState = function replaceState(newState) {
        Debug.setState(key, function() {
            return newState;
        }, options.withOverload);
        setState(newState);
    };
    var resetState = function resetState() {
        if (!options.withOverload) {
            throw new Error('resetState is not allowed without overload');
        }
        Debug.resetState(key);
        setState(getInitialState(key, initialState));
    };
    // @todo: [CTCORE-10434] Refactor to use useSyncExternalStore hook
    useEffect(function() {
        var handleStateChange = function handleStateChange() {
            setState(getInitialState(key, initialState));
        };
        PubSub.subscribe(key, handleStateChange);
        return function() {
            PubSub.unsubscribe(key, handleStateChange);
        };
    }, [
        key,
        initialState
    ]);
    return {
        addState: addState,
        replaceState: replaceState,
        resetState: resetState,
        state: state
    };
};

//# sourceMappingURL=useDebugState.js.map